import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { ConstantsService } from '@core/services/constants.service';
import { GeneralsService } from '@core/services/generals.service';
import { ConstantsEditComponent } from '@modules/constants/constants-edit/constants-edit.component';
import { Constants } from '@shared/class/constants.class';
import { Constant } from '@shared/interfaces/constant';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-constants-list',
  templateUrl: './constants-list.component.html'
})
export class ConstantsListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public actions: Array<string> = [this.appConfig.ACTIONS.edit.id];

  public location = 'constants';
  public dataSource: MatTableDataSource<Constant>;
  public selection = new SelectionModel<Constant>(true, []);
  public constantsList: Array<Constant> = [];
  public constant: Constant;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public constantsService: ConstantsService
  ) {
    this.constants.displayedColumns = [
      'id',
      'name',
      'description',
      'value',
      this.appConfig.ACTIONS.edit.id
    ];
    const result = this.generalsService.getActions(
      this.constants.displayedColumns,
      this.actions,
      this.location
    );

    this.constants.displayedColumns = result.displayedColumns;
    this.constants.displayedActions = result.displayedActions;
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constantsList = [];
    this.constants.loading = true;
    this.constantsService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          result.data.forEach((element: any) => {
            this.constant = {
              id: element.id,
              name: element.attributes.name,
              description: element.attributes.description,
              value: element.attributes.value
            };
            this.constantsList.push(this.constant);
          });
          if (this.constantsList.length) {
            this.dataSource = new MatTableDataSource(this.constantsList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(item: Constant) {
    let dialog: any;

    this.constants.message = this.appConfig.LANG.message.editSuccess;
    dialog = this.generalsService.modal(ConstantsEditComponent, item);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        this.generalsService.afterClosed(this, result, this.constants.message);
      });
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }
}
